import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfig } from "@/contexts/cdpConfig";
import { useContactContext } from "@/contexts/contact";
import { useCustomerAction } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { useFormContext } from "react-hook-form";
export const testId = "cdp-sections-units-unit-buttons";
export const UnitButtons = ({ ...unit }) => {
    const isPreviewMode = useConfig().previewMode;
    const { customerActionExposeInteraction } = useCustomerAction();
    const { setValue } = useFormContext();
    const { toggleModal } = useContactContext();
    const { t } = useI18n();
    const trackCustomerActionLeadMailInterestView = async () => await customerActionExposeInteraction([
        { key: "interaction", value: "openContactForm" },
    ]);
    const handlePress = (av_zone) => {
        if (isPreviewMode)
            return;
        const newMessage = t("pdpSeeker_unitTable_askFloorPlanDefaultMessage");
        if (av_zone === "pdp_floor_plan") {
            setValue("message", newMessage);
        }
        trackCustomerActionLeadMailInterestView();
        toggleModal({
            av_zone,
            legacyTrackingInfos: av_zone,
            unitId: unit === null || unit === void 0 ? void 0 : unit.id,
        });
    };
    return (_jsxs(Box, { display: "flex", alignItems: "center", marginLeft: {
            "breakpoint.base": 0,
            "breakpoint.lg": "spacing.8",
        }, marginTop: {
            "breakpoint.base": "spacing.16",
            "breakpoint.lg": 0,
        }, testId: testId, children: [_jsx(Button, { size: "40", variant: "secondary", marginRight: "spacing.8", isFullWidth: {
                    "breakpoint.base": true,
                    "breakpoint.lg": false,
                }, onPress: () => handlePress("pdp_floor_plan"), children: t("pdpSeeker_unitTable_askFloorPlanButtonTitle_alt") }), _jsx(Button, { size: "40", isFullWidth: {
                    "breakpoint.base": true,
                    "breakpoint.lg": false,
                }, onPress: () => handlePress("pdp_contact_entry_unit"), children: t("pdpSeeker_unitTable_contactButtonTitle") })] }));
};
